import React from 'react';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-content">
          <h1>Terms of Service</h1>
          
          <div className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using JobsOpportunity.in ("the Website"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </div>

          <div className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              JobsOpportunity.in is an informational job-sharing platform that aggregates and displays job opportunities from various sources. We provide:
            </p>
            <ul>
              <li>Job listings and career opportunities</li>
              <li>Career-related blog content</li>
              <li>Job search and filtering tools</li>
              <li>Email notifications for job alerts</li>
            </ul>
            <p>
              <strong>Important:</strong> We are not a job placement agency and do not participate in the recruitment process.
            </p>
          </div>

          <div className="terms-section">
            <h2>3. User Responsibilities</h2>
            <p>As a user of this website, you agree to:</p>
            <ul>
              <li>Provide accurate and truthful information</li>
              <li>Use the service for lawful purposes only</li>
              <li>Not attempt to gain unauthorized access to our systems</li>
              <li>Not interfere with the proper working of the website</li>
              <li>Respect intellectual property rights</li>
              <li>Not use automated tools to access our services</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>4. Privacy and Data Collection</h2>
            <p>
              We collect and process personal data as described in our Privacy Policy. By using our service, you consent to:
            </p>
            <ul>
              <li>Collection of your personal information for service provision</li>
              <li>Use of cookies and similar technologies</li>
              <li>Processing of your data for job matching and notifications</li>
              <li>Sharing of data with third-party service providers</li>
            </ul>
            <p>
              For detailed information about data collection and usage, please refer to our Privacy Policy.
            </p>
          </div>

          <div className="terms-section">
            <h2>5. Third-Party Services and Advertising</h2>
            <p>
              Our website may display third-party advertisements and use third-party services including:
            </p>
            <ul>
              <li>Google Ads and Google Analytics</li>
              <li>Social media platforms</li>
              <li>Email service providers</li>
              <li>Cloud hosting services</li>
            </ul>
            <p>
              These third parties may collect information about your use of our website and may use cookies and similar technologies. We do not control these third-party services and are not responsible for their privacy practices.
            </p>
          </div>

          <div className="terms-section">
            <h2>6. Intellectual Property</h2>
            <p>
              All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of JobsOpportunity.in or its content suppliers and is protected by copyright laws.
            </p>
            <p>
              Company logos and trademarks displayed on our website belong to their respective owners. We do not claim ownership of these materials.
            </p>
          </div>

          <div className="terms-section">
            <h2>7. Disclaimers and Limitations</h2>
            <p>
              <strong>Service Disclaimer:</strong> We provide job information for informational purposes only. We do not guarantee:
            </p>
            <ul>
              <li>The accuracy or completeness of job listings</li>
              <li>That you will be hired for any position</li>
              <li>The availability of any specific job</li>
              <li>The quality or suitability of any employer</li>
            </ul>
            <p>
              <strong>Limitation of Liability:</strong> In no event shall JobsOpportunity.in be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our service.
            </p>
          </div>

          <div className="terms-section">
            <h2>8. Termination</h2>
            <p>
              We may terminate or suspend your access to our service immediately, without prior notice, for any reason, including breach of these Terms of Service.
            </p>
            <p>
              Upon termination, your right to use the service will cease immediately.
            </p>
          </div>

          <div className="terms-section">
            <h2>9. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new Terms of Service on this page and updating the "Last Updated" date.
            </p>
            <p>
              Your continued use of the service after any changes constitutes acceptance of the new terms.
            </p>
          </div>

          <div className="terms-section">
            <h2>10. Governing Law</h2>
            <p>
              These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in India.
            </p>
          </div>

          <div className="terms-section">
            <h2>11. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <ul>
              <li>Email: info@jobsopportunity.in</li>
              <li>Phone: +91-9380867233</li>
              <li>Website: https://jobsopportunity.in</li>
            </ul>
          </div>

          <div className="terms-footer">
            <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
            <p>
              By using JobsOpportunity.in, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService; 